import React, { useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import Slider from "react-slick";
import { fetchAuspiciantesPrem } from "../action/AuspicianteActionsPrem";
import { Link } from "react-router-dom";

export const Auspiciantes = React.memo(({ ciudad = '' }) => {
  const dispatch = useDispatch();
  
  // Memoizar configuración del servidor
  const config_server = useMemo(() => {
    return JSON.parse(localStorage.getItem("configServer"));
  }, []);
  
  const auspiciantesPrem = useSelector((state) => state.auspiciantesPrem);

  useEffect(() => {
    const loadAuspiciantesPrem = () => dispatch(fetchAuspiciantesPrem(ciudad));
    loadAuspiciantesPrem();
  }, [dispatch, ciudad]);

  // Memoizar settings del slider con configuración responsiva
  const settings = useMemo(() => ({
    dots: true,
    fade: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
          adaptiveHeight: true,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          dots: true,
          autoplay: true,
          autoplaySpeed: 3000,
          adaptiveHeight: true,
        }
      }
    ]
  }), []);

  // Memoizar el contenido renderizado
  const renderedContent = useMemo(() => {
    if (!auspiciantesPrem.items) {
      return <div className="imagen-home-promociones1-oculto"></div>;
    }

    return (
      <div className="auspiciantes-container">
        <Slider
          className="auspiciantes-slider"
          {...settings}
        >
          {auspiciantesPrem.items.map((auspiciante) => {
            return (
              <div key={auspiciante.id_auspiciante} className="auspiciante-slide">
                <Link 
                  target="_blank" 
                  to={{ pathname: auspiciante.webpage_auspiciante }}
                  className="auspiciante-link"
                >
                  <div className="auspiciante-image-container">
                    <img
                      className='auspiciante-image'
                      src={`${config_server.linkImageAuspiciante}${auspiciante.imagen_auspiciante}`}
                      alt={`Auspiciante ${auspiciante.nombre_auspiciante || 'Promoción'}`}
                      loading="lazy"
                    />
                  </div>
                </Link>
              </div>
            );
          })}
        </Slider>
        
        {/* Estilos CSS inline para garantizar funcionamiento */}
        <style jsx>{`
          .auspiciantes-container {
            width: 100%;
            height: auto;
            min-height: 60px;
            max-height: none;
            overflow: hidden;
            border-radius: 8px;
            padding: 8px;
            box-shadow: 0 2px 8px rgba(0,0,0,0.2);
            background: rgba(255,255,255,0.05);
          }
          
          .auspiciantes-slider {
            width: 100%;
            height: auto;
          }
          
          .auspiciante-slide {
            width: 100%;
            height: auto;
            display: flex !important;
            align-items: center;
            justify-content: center;
            padding: 5px;
          }
          
          .auspiciante-link {
            display: block;
            width: 100%;
            height: auto;
            text-decoration: none;
            transition: transform 0.3s ease;
          }
          
          .auspiciante-link:hover {
            transform: scale(1.02);
          }
          
          .auspiciante-image-container {
            width: 100%;
            height: auto;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            border-radius: 6px;
            padding: 3px;
            background: rgba(255,255,255,0.1);
          }
          
          .auspiciante-image {
            width: 100%;
            height: auto;
            max-width: 100%;
            max-height: 200px;
            object-fit: contain;
            object-position: center;
            border-radius: 4px;
            transition: all 0.3s ease;
            display: block;
          }
          
          /* Responsive design - Adaptación dinámica */
          @media (min-width: 481px) {
            .auspiciante-image {
              max-height: 250px;
            }
            
            .auspiciantes-container {
              padding: 10px;
            }
            
            .auspiciante-slide {
              padding: 8px;
            }
            
            .auspiciante-image-container {
              padding: 5px;
            }
          }
          
          @media (min-width: 769px) {
            .auspiciante-image {
              max-height: 300px;
            }
            
            .auspiciantes-container {
              padding: 12px;
            }
            
            .auspiciante-slide {
              padding: 10px;
            }
            
            .auspiciante-image-container {
              padding: 8px;
            }
          }
          
          /* Mejoras para el slider */
          .slick-slider {
            width: 100% !important;
            height: auto !important;
          }
          
          .slick-list {
            height: auto !important;
          }
          
          .slick-track {
            height: auto !important;
          }
          
          .slick-slide {
            height: auto !important;
          }
          
          .slick-slide > div {
            height: auto !important;
          }
          
          /* Dots personalizados */
          .slick-dots {
            bottom: 8px;
          }
          
          .slick-dots li button:before {
            color: #fff;
            opacity: 0.7;
            font-size: 8px;
          }
          
          .slick-dots li.slick-active button:before {
            opacity: 1;
            color: #007bff;
          }
          
          /* Asegurar que las imágenes mantengan proporciones */
          .auspiciante-image {
            flex-shrink: 0;
          }
        `}</style>
      </div>
    );
  }, [auspiciantesPrem.items, settings, config_server.linkImageAuspiciante]);

  return (
    <div className="auspiciantes-wrapper">
      {renderedContent}
    </div>
  );
});

Auspiciantes.displayName = 'Auspiciantes';

